import { __decorate, __metadata } from "tslib";
import { Serialize } from '@ftr/serialization';
import { IsDefined, IsEnum, IsUUID, ValidateIf } from 'class-validator';
import { PagedQuery } from '../core';
import { UserGroupPermissionId } from './UserGroupPermissionId';
/**
 * The maximum number of records per page for a user group list
 */
export const USER_GROUP_LIST_SIZE = 100;
/**
 * URL query parameters used when requesting user groups for a court system.
 */
export class GetUserGroupsQuery extends PagedQuery {
}
__decorate([
    IsDefined(),
    IsUUID(),
    __metadata("design:type", String)
], GetUserGroupsQuery.prototype, "courtSystemId", void 0);
__decorate([
    ValidateIf(ug => ug.permissionId !== undefined),
    IsEnum(UserGroupPermissionId),
    __metadata("design:type", String)
], GetUserGroupsQuery.prototype, "permissionId", void 0);
__decorate([
    Serialize(() => Boolean),
    __metadata("design:type", Object)
], GetUserGroupsQuery.prototype, "isEnabled", void 0);
